// Override theme breakpoint for product slider (iPad Pro compatibility)
if (window.theme?.sizes) {
  window.theme.sizes.large = 1048;
}

import '../components/countdown/scripts';
import '../components/styleGuide/scripts';
import '../features/cartWidget/scripts';
import '../features/colorSwatches/scripts';
import '../features/filterSelects/scripts';
import '../features/filteredProductList/scripts';
import '../features/klaviyo/scripts';
import '../features/navDrawer/scripts';
import '../features/product/scripts';
import '../features/shippingCutoff/scripts';
import '../features/tryOn/scripts';
import '../features/variantSwitch/scripts';
import '../features/videoAutoplay/scripts';
import '../features/visionTest/scripts';
